<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top="0" :rules="rules">
      <el-row>
        <el-col :span="5">
          <!-- <el-form-item label="速记码" prop="shortCode">
            <el-input
              v-model="query.shortCode"
              placeholder="请输入速记码"
              @input="propertyFilter"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="小区分组" prop="communityGroup">
            
            <el-select style="width: 100%" v-model="query.communityGroup" @change="communityGroupChangeHandler">
              <el-option
                v-for="item in communityGroupList"
                :key="item"
                :value="item.dictKey"
                :label="item.dictValue"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="小区名称" prop="communityId">
            
                <avue-input-tree 
                    node-key="id"
                    :props="defaultProps"
                    default-expand-all 
                    v-model="query.communityId" 
                    placeholder="请选择小区" 
                    type="select" 
                    @change="communityIdChange"
                    :dic="allPropertyListCopy"
                >
                </avue-input-tree>
            <!-- <el-select v-model="query.communityId" placeholder="全部">
              <el-option
                style="padding-left: 10px;"
                v-for="item in allPropertyListCopy"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="票据号" prop="invoiceNo">
            <el-input v-model="query.invoiceNo" placeholder="请输入票据号"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item label="收费时间" prop="dateRange">
            <el-date-picker
              style="width:42%;"
              v-model="query.payStartTime"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            到
            <el-date-picker
              style="width:42%;"
              v-model="query.payEndTime"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <el-form-item label="缴费人" prop="payManName">
            <el-input v-model="query.payManName" placeholder="请输入缴费人"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="缴费方式" prop="payType">
            <el-select v-model="query.payType" clearable placeholder="全部">
              <el-option
                style="padding-left: 10px;"
                v-for="item in payTypeList"
                :key="item.dictKey"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="应缴金额" prop="totalShouldAmount">
            <el-input v-model="query.totalShouldAmount" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="实缴金额" prop="totalPayAmount">
            <el-input v-model="query.totalPayAmount" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-button-group style="margin-bottom: 20px;">
            <el-button type="primary" @click="submitSearchForm" style="margin-left: 25px;"
              >搜索</el-button
            >
            <el-button @click="searchReset" style="margin-left: 5px;">清空</el-button>
          </el-button-group>
        </el-col>
      </el-row>
    </el-form>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot-scope="scope" slot="menu">
        <el-button
          type="text"
          size="small"
          icon="el-icon-caret-left"
          @click="rowUpdateForm('return', scope.row, scope.index)"
          >还 原</el-button
        >
        <!--        <el-button-->
        <!--          type="text"-->
        <!--          size="small"-->
        <!--          icon="el-icon-caret-right"-->
        <!--          @click="rowUpdateForm('add', scope.row, scope.index)"-->
        <!--          >调 用</el-button-->
        <!--        >-->
        <el-button
          type="text"
          size="small"
          icon="el-icon-refresh"
          @click="rowUpdateForm('update', scope.row, scope.index)"
          >更 新</el-button
        >
      </template>
    </avue-crud>
  </basic-container>
</template>
<script>
import { getList, getTotalMoney, update } from '@/api/v4ward/payback/feepayprocess';
import { mapGetters } from 'vuex';
    import _ from 'lodash';
import { getDictionary, getProperty, getCommunityGroupList } from '../../../api/common';
import { getOptionNode } from '../../../api/v4ward/property/baseproperty';

export default {
  data() {
    return {
        defaultProps:{
            children: 'children',
            label: 'title',
        value: 'id',
        },
      form: {},
      communityGroupList:[],
      query: {
        dateRange: [],
        shortCode: '',
        communityId: '',
        communityGroup: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      payTypeList: [],
      //如果已经根据速记码查询过了小区信息则为true
      propertyIsQuery: false,
      allPropertyList: [],
      allPropertyListCopy: [],
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        border: true,
        addBtn: false,
        editBtn: false,
        excelBtn: true,
        delBtn: false,
        viewBtn: false,
        selection: true,
        index: true,
        indexLabel: '序号',
        indexWidth: '60',
        column: [
          {
            label: '收费主表ID',
            prop: 'id',
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入收费主表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '速记码',
            prop: 'shortCode',
            searchSpan: 6,
            hide: true,
            rules: [
              {
                required: true,
                message: '请输入收费主表ID',
                trigger: 'change',
              },
            ],
          },
          {
            label: '房屋地址信息',
            prop: 'roomName',
            width: '120',
            rules: [
              {
                required: true,
                message: '请输入房屋地址信息',
                trigger: 'change',
              },
            ],
          },
          {
            label: '缴费人',
            prop: 'payManName',
            searchFilterable: true,
            width: '100',
            rules: [
              {
                required: true,
                message: '请输入收费人员',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费单号',
            prop: 'paybillNo',
            width: '100',
            rules: [
              {
                required: true,
                message: '请输入收费单号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费时间',
            prop: 'payTime',
            width: '100',
            rules: [
              {
                required: true,
                message: '请输入付款时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费金额',
            prop: 'totalPayAmount',
            width: '60',
            rules: [
              {
                required: true,
                message: '请输入实收总金额',
                trigger: 'change',
              },
            ],
          },
          {
            label: '调用时间',
            prop: 'performTime',
            width: '100',
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '调用状态',
            prop: 'recordStatus',
            type: 'select',
            width: '60',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_perfrom_status',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '调用结果',
            prop: 'perfromResult',
            type: 'select',
            width: '60',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_perfrom_result',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '支付方式',
            prop: 'payType',
            // search: true,
            type: 'select',
            width: '60',
            dicUrl: '/api/blade-system/dict/dictionary?code=pay_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message: '请输入支付方式',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收银员',
            prop: 'cashierName',
            width: '80',
            rules: [
              {
                required: true,
                message: '请输入收银员',
                trigger: 'change',
              },
            ],
          },
          {
            label: '票据号',
            prop: 'invoiceNo',
            width: '160',
            rules: [
              {
                required: true,
                message: '请输入票据号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '收费备注',
            prop: 'payRemark',
            width: '200',
            rules: [
              {
                required: true,
                message: '请输入收费备注',
                trigger: 'change',
              },
            ],
          },
          {
            label: '操作类型',
            prop: 'type',
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.feepay_add, false),
        viewBtn: this.vaildData(this.permission.feepay_view, false),
        delBtn: this.vaildData(this.permission.feepay_delete, false),
        editBtn: this.vaildData(this.permission.feepay_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.initDefaultDateRange();
  },
  mounted() {
    let this_ = this;
    this.initPayTypeList();
      getCommunityGroupList().then((res)=>{
        this.communityGroupList = res.data;
        this.query.communityGroup = res.data[0].dictKey;
          this.initPropertyList((data)=>{
              this.query.communityId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              this.onLoad();
          });
      });
  },
  methods: {
        communityGroupChangeHandler(val){
          let this_ = this;
          this.allPropertyListCopy = [];
            this.initPropertyList((data)=>{
              this.query.communityId = data[0].id;
              this.query = _.cloneDeep(this_.query);
              this.onLoad();
            });
        },
    initPayTypeList() {
      getDictionary('pay_type').then((data) => {
        this.payTypeList = data.data;
      });
    },
    initPropertyList(cb) {
      getOptionNode({communityGroup:this.query.communityGroup|| ''}).then((data) => {
        if (this.propertyIsQuery) {
          this.allPropertyList = data.data;
        } else {
          this.allPropertyList = data.data;
          this.allPropertyListCopy = data.data;
        }
        cb(data.data);
      });
    },
    initDefaultDateRange() {
      this.query.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      this.query.payStartTime=this.getCurrentMonthFirst()+" 00:00:00"
      this.query.payEndTime=this.getCurrentMonthLast()+" 23:59:59"
    },
    getCurrentMonthFirst: function () {
      var date = new Date();
      date.setDate(1);
      var month = parseInt(date.getMonth() + 1);
      var day = date.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    getCurrentMonthLast: function () {
      var date = new Date();
      var currentMonth = date.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
      var oneDay = 1000 * 60 * 60 * 24;
      var lastTime = new Date(nextMonthFirstDay - oneDay);
      var month = parseInt(lastTime.getMonth() + 1);
      var day = lastTime.getDate();
      if (month < 10) {
        month = '0' + month;
      }
      if (day < 10) {
        day = '0' + day;
      }
      return date.getFullYear() + '-' + month + '-' + day;
    },
    submitSearchForm() {
      this.searchChange(this.query);
    },
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },

    rowUpdateForm(type, row, index, loading, done) {
      let viewData = '';
      if (type === 'return') {
        viewData = '确定将选择缴费记录进行【还原】操作?';
      } else if (type === 'add') {
        viewData = '确定将选择缴费记录进行再次【调用】操作?';
      } else if (type === 'update') {
        viewData = '确定将选择缴费记录进行【更新】操作?';
      }
      row.type = type;
      this.$confirm(viewData, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        update(row).then(
          () => {
            loading();
            this.onLoad();
            this.$message.success('操作成功!');
          },
          (error) => {
            done();
            console.log(error);
          }
        );
      });
    },

    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },

    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.tool.clearObject(this.query)
      this.initDefaultDateRange()
      // this.query.dateRange = [this.getCurrentMonthFirst(), this.getCurrentMonthLast()];
      //清空搜索框后，因为速记码被清空，小区下拉恢复为全部数据
      this.propertyFilter();
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page, params = {}) {
      // if (params.dateRange) {
      //   params.payStartTime = params.dateRange[0];
      //   params.payEndTime = params.dateRange[1];
      // }
      if (this.propertyIsQuery && !this.query.communityId) {
        if (this.allPropertyListCopy.length > 0) {
          this.query.communityId = this.allPropertyListCopy[0].id;
        } else {
          this.$message.error('未查询到任何小区，请重新输入速记码!');
          console.log(0);
          return;
        }
      }
      page = page || this.page;
      this.loading = true;
      if (!this.query.communityId) {
        getOptionNode({}).then((data) => {
          this.query.communityId = data.data[0].id;
          getList(
            Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)
          ).then(({ data }) => {
            this.page.total = data.total;
            this.data = data.records;
            this.loading = false;
            this.selectionClear();
          });
          getTotalMoney(Object.assign({}, this.query)).then(({ data }) => {
            this.query.totalShouldAmount = data.totalShouldAmount;
            this.query.totalPayAmount = data.totalPayAmount;
          });
        });
        return;
      }
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
      getTotalMoney(Object.assign({}, this.query)).then(({ data }) => {
        this.query.totalShouldAmount = data.totalShouldAmount;
        this.query.totalPayAmount = data.totalPayAmount;
      });
    },
    //监听速记码变化过滤房产信息
    propertyFilter() {
      let val = this.query.shortCode;
      if (val) {
        //速记码存在,改变小区过滤状态，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList.filter(function (item) {
          return item.shortCode.indexOf(val) > -1;
        });
        this.propertyIsQuery = true;
      } else {
        //val为空时，还原数组,将过滤状态还原，清除小区下拉框选中状态
        this.allPropertyListCopy = this.allPropertyList;
        this.propertyIsQuery = false;
        this.query.communityId = '';
      }
      if (this.allPropertyListCopy.length > 0){
        // this.query.communityId = this.allPropertyListCopy[0].id;
        this.query = Object.assign({},this.query,{communityId:this.allPropertyListCopy[0].id});
        }
      else this.query.communityId = '';
    },
  },
};
</script>

<style></style>
